import React from 'react';
import { Loader as DSLoader } from './ds';

// Back-compat shim: older pages import this default Loader with a size of
// "small|medium|large" and a `text` label. It now renders the DS candlestick
// Loader so the whole app shares ONE loading mark (this used to be a separate
// infinity-symbol spinner tinted with currentColor).
// New code should import { Loader } from 'components/ds' directly.
const SIZE_MAP = { small: 'sm', medium: 'md', large: 'lg' };

const Loader = ({ size = 'medium', text = 'Loading...' }) => (
  <DSLoader size={SIZE_MAP[size] || 'md'} label={text} />
);

export default Loader;
